export default __webpack_public_path__ + "static/media/logo.8e4c25c8.png";